import { cn } from "@/lib/utils";

const STATUS_LABELS = {
    pending: "Pending",
    approved: "Approved",
    checked_in: "Checked In",
    checked_out: "Checked Out",
    rejected: "Rejected",
};

export default function StatusBadge({ status, className }) {
    const label = STATUS_LABELS[status] || status;
    return (
        <span
            data-testid={`badge-status-${status}`}
            className={cn(
                "inline-flex items-center px-2.5 py-0.5 rounded-full text-[10px] uppercase tracking-widest font-bold",
                `badge-${status}`,
                className,
            )}
        >
            {label}
        </span>
    );
}
